export const GOOGLE_API_KEY = "AIzaSyAV0gzd5cuzP_GX6kgO3di-mJ1l7q6jeTI"

